import React from "react";
import logoZippy from "@/assets/logo-zippy.png";

/**
 * ZIPPY — the FixyDany bee. PNG with a transparent background; never recoloured
 * or redrawn.
 *
 * ZIPPY is the brand mark and has exactly one pose. It is NOT the assistant:
 * everything Dany renders goes through `ds/dany/DanyAvatar`, which is a
 * different character with seven states (BRIEF-FABLE.md §2, "Dany ≠ ZIPPY").
 *
 * PORT NOTE (DY1.4): `src` defaults to the bundled asset rather than the design
 * system's relative `assets/logo-zippy.png`, which only resolves from the kits'
 * own directory.
 */
export function FixyBeeMark({ size = 40, animated = false, src = logoZippy, className = "", style = {}, ...rest }) {
  return (
    <img
      src={src}
      alt="FixyDany"
      width={size}
      height={size}
      draggable={false}
      className={className}
      style={{
        display: "inline-block", objectFit: "contain",
        animation: animated ? "fixy-bee-wings 0.9s ease-in-out infinite" : undefined,
        ...style,
      }}
      {...rest}
    />
  );
}

export default FixyBeeMark;
